import { JobLocationType, JobEmploymentType } from './JobSearchResult/types'

export enum TabType {
  recommendation = 'recommendation',
  search = 'search',
}

export const SHOW_CHECK_PROFILE_BANNER_STORAGE_KEY = 'showCheckProfileBanner'

export const ONBOARDING_STRUCTURED_RESUME_DATA_KEY = 'onboardingStructuredResumeData'

export enum RecommendationsRequiredAttributes {
  Profile = 'profile',
  TargetRole = 'target_roles',
  TargetLocation = 'target_locations',
  WorkExperience = 'work_experience',
  WorkExperienceWithDetails = 'work_experience_with_description_and_title',
}

export interface Filters {
  onlyAutoApplyJobs: boolean
  postedWithinDays: number
  radius: number
  jobLocationType: JobLocationType | null
  jobType: JobEmploymentType | null
}

export enum LocationCategory {
  Country = 'country',
  State = 'state',
  County = 'county',
  City = 'city',
  ZipCode = 'zip_code',
}

export type RecommendationsRequiredAttributesType = `${RecommendationsRequiredAttributes}`
